import { Transferforofficer13Component } from "../../../components/SupportSystem/SupportForm/Transferforofficer13Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Transferforofficer13Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Transferforofficer13Component/>
            <Footer />
        </div>   
        // 
    )
    
}